// extracted by mini-css-extract-plugin
module.exports = {"commingWrapper":"styles_commingWrapper__2whDu","commingImg":"styles_commingImg__3oW_g","comming":"styles_comming__2OfnV"};